import io from "socket.io-client";

import { getConfig } from "../../../../../config/app";
import { Events } from "./events";
import {
  IBusinessUnit,
  IQuoteFormValues,
  SocketResponse,
  OfferSelectedParams,
  OfferSelectedResponse,
  GetOfferResponse
} from "./types";

const { host, path } = getConfig("quoteFormConnectorSocket");

class SocketQuoteForm {
  private socketQuoteForm?: SocketIOClient.Socket;

  constructor() {
    this.socketQuoteForm = undefined;
  }

  public connect = () => {
    this.socketQuoteForm = io.connect(host, { path });
    return this.socketQuoteForm;
  };

  public getCurrentSocket = () => {
    return this.socketQuoteForm || this.connect();
  };

  public saveQuoteForm = (
    form: IQuoteFormValues,
    businessUnit: IBusinessUnit,
    responseSaveQuoteForm: SocketResponse
  ) => {
    const currentSocket = this.getCurrentSocket();
    currentSocket.once(Events.ResponseSaveQuoteForm, responseSaveQuoteForm);
    currentSocket.emit(Events.SaveQuoteForm, { form, ...businessUnit });
  };

  public getQuoteFormById = (
    formId: string,
    businessUnit: IBusinessUnit,
    responseGetQuoteFormById: SocketResponse
  ) => {
    const currentSocket = this.getCurrentSocket();
    currentSocket.once(Events.ResponseGetQuoteFormById, responseGetQuoteFormById);
    currentSocket.emit(Events.GetQuoteFormById, {
      form: { id: formId },
      ...businessUnit
    });
  };

  public requoteForm = (
    formId: string,
    businessUnit: IBusinessUnit,
    responseSaveQuoteForm: SocketResponse
  ) => {
    const currentSocket = this.getCurrentSocket();
    currentSocket.once(Events.ResponseSaveQuoteForm, responseSaveQuoteForm);
    currentSocket.emit(Events.RequoteForm, {
      form: { id: formId },
      ...businessUnit
    });
  };

  public offerSelected = (
    { formId, offerId, ...params }: OfferSelectedParams,
    businessUnit: IBusinessUnit,
    responseOfferSelectedProcessed: OfferSelectedResponse
  ) => {
    const currentSocket = this.getCurrentSocket();

    currentSocket.once(Events.OfferSelected, responseOfferSelectedProcessed);
    currentSocket.emit(Events.OfferSelected, {
      form: {
        id: formId,
        offerId
      },
      ...params,
      ...businessUnit
    });
  };

  public getOfferById = (
    offerId: string,
    formId: string,
    businessUnit: IBusinessUnit,
    responseGetOfferById: GetOfferResponse
  ) => {
    const currentSocket = this.getCurrentSocket();
    currentSocket.once(Events.ResponseGetOfferById, responseGetOfferById);
    currentSocket.emit(Events.GetOfferById, {
      form: { formId: formId, id: offerId },
      ...businessUnit
    });
  };

  public disconnect = () => {
    const currentSocket = this.getCurrentSocket();
    currentSocket.disconnect();
  };
}

export { SocketQuoteForm };
